import { render, staticRenderFns } from "./SeriesPoints.vue?vue&type=template&id=04f8cbf6&"
import script from "./SeriesPoints.vue?vue&type=script&lang=js&"
export * from "./SeriesPoints.vue?vue&type=script&lang=js&"
import style0 from "./SeriesPoints.vue?vue&type=style&index=0&id=04f8cbf6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports